<template>
  <span class="rp-chip" :class="'rp-chip--' + status" :title="titulo">
    <svg v-if="status === 'sim'" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
      <polyline points="20 6 9 17 4 12"></polyline>
    </svg>
    <template v-else-if="status === 'breve'">Em breve</template>
    <template v-else>—</template>
  </span>
</template>

<script setup>
// Selo de situação de um recurso (sim | breve | nao) da tela "Recursos disponíveis".
// Os estilos .rp-chip* ficam no RecursosPortaisModal (usam as variáveis de cor do modal).
import { computed } from 'vue';
import { rotuloStatus } from '@/config/recursosPortais';

const props = defineProps({
  status: { type: String, default: 'nao' },
  rotulo: { type: String, default: '' },
});

const titulo = computed(() => [props.rotulo, rotuloStatus[props.status]].filter(Boolean).join(' — '));
</script>
